import { Alert } from "@hightouch/htui";
import type { EmbedNotice } from "src/pages/ad-studio/insights/performance/types";

const NoticeAlert = ({ notice }: { notice: EmbedNotice }) => {
  switch (notice) {
    case "baseline-not-supported": {
      return (
        <Alert
          type="info"
          title="Baseline comparisons aren't available here"
          message="These results show each metric without the comparison the agent asked for."
        />
      );
    }
    default: {
      return notice satisfies never;
    }
  }
};

export const EmbedNotices = ({
  notices,
}: {
  notices: readonly EmbedNotice[];
}) => (
  <>
    {notices.map((notice) => (
      <NoticeAlert key={notice} notice={notice} />
    ))}
  </>
);
